import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Dialog from '@/components/Dialog'
import ProductImage from '@/components/ProductImage'
import { bookTitleSelector } from '@/selectors'
import { translate } from '@/utils/translations'

const ImageZoomDialog = ({ imageUrl, isShowing, setIsShowing }) => {
  const bookTitle = useSelector(bookTitleSelector)

  return (
    <Dialog
      heading=''
      id='pdp-cover-image-dialog'
      isShowing={isShowing}
      onChangeShow={setIsShowing}
    >
      <ProductImage
        alt={`${translate('product_display.cover_image')} ${bookTitle}`}
        className='pdp-cover-image'
        url={imageUrl}
        width={720}
      />
    </Dialog>
  )
}

ImageZoomDialog.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  isShowing: PropTypes.bool.isRequired,
  setIsShowing: PropTypes.func.isRequired
}

export default ImageZoomDialog
